<template>
  <v-container>
    <v-row>
      <v-col>
        <h3>Restore Log</h3>
      </v-col>
    </v-row>
    <v-col>
      <v-data-table
        :headers="headers"
        :items="logs"
        class="elevation-1"
      >
      </v-data-table>
    </v-col>
  </v-container>
</template>

<script>

import {
  mapActions,
  mapGetters,
} from 'vuex';

export default {
  name: 'RestoreLogs',
  data() {
    return {
      headers: [
        { text: 'Event', value: 'event' },
        { text: 'Database', value: 'data' },
        { text: 'Backup filename', value: 'filename' },
        { text: 'User', value: 'user' },
        { text: 'Date/Time', value: 'dateTime' },
      ],
    };
  },
  created() {
    this.fetchRestoreLogs();
  },
  computed: {
    ...mapGetters('jobs', ['restoreLogs']),
    logs() {
      return this.restoreLogs;
    },
  },
  methods: {
    ...mapActions('jobs', ['getRestoreLogs']),
    fetchRestoreLogs() {
      this.getRestoreLogs();
    },
  },
};
</script>
